module.exports = __webpack_public_path__ + "static/media/heroGraphic1400.c28c87da.png";